import FileDownload from 'js-file-download'
import React, { useEffect, useState, useCallback } from 'react'
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
import 'react-datepicker/dist/react-datepicker.css'
import DatePicker from 'react-datepicker'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify'
import {
  Button,
  ButtonGroup,
  Icon,
  Input,
  Label,
  Message,
  Pagination,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableHeaderCell,
  TableRow,
} from 'semantic-ui-react'
import api from '../../services/api'

import { ContainerHeader, ContainerSemantic } from './styles'

const qtdSelectOptions = [
  { key: '20', value: '20', text: '20' },
  { key: '50', value: '50', text: '50' },
  { key: '100', value: '100', text: '100' },
]

export default function Contatos() {
  const [showSearch, setShowSearch] = useState(false)
  const [contatos, setContatos] = useState([])
  const profile = useSelector((state) => state.user.profile)
  const [did, setDid] = useState('')
  const [ident, setIdent] = useState('')
  const [campoCustom, setCampoCustom] = useState('')
  const [downloadLoading, setDownloadLoading] = useState(false)
  const [selectqtdContatos, setSelectqtdContatos] = useState('20')
  const [totalPages, setTotalPages] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)
  const [totalCount, setTotalCount] = useState(0)

  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)

  const getContacts = useCallback(async () => {
    try {
      const { data } = await api.get('/contacts', {
        params: {
          descricao: ident,
          did: did ? did : undefined,
          campoCustom: campoCustom ? campoCustom : undefined,
          page: currentPage - 1,
          limit: selectqtdContatos,
        },
      })
      setContatos(data)
      setTotalPages(data.count / selectqtdContatos)
      setTotalCount(data.count)
    } catch (error) {
      toast.error('Erro ao buscar a lista de contatos')
    }
  }, [ident, did, campoCustom, selectqtdContatos, currentPage])

  const handleExport = useCallback(() => {
    setDownloadLoading(true)

    api
      .get('/export/contacts', {
        params: {
          fk_id_dominio: profile.id_dominio,
        },
        responseType: 'blob',
      })
      .then((response) => {
        setDownloadLoading(false)
        FileDownload(response.data, 'contatos.xlsx')
      })
      .catch((error) => {
        toast.error('Erro ao exportar contatos')
        setDownloadLoading(false)
      })
  }, [profile.id_dominio])

  const handleExportUpdated = useCallback(() => {
    setDownloadLoading(true)

    api
      .get('/export/contacts/updated', {
        params: {
          fk_id_dominio: profile.id_dominio,
        },
        responseType: 'blob',
      })
      .then((response) => {
        setDownloadLoading(false)
        FileDownload(response.data, 'contatos_atualizados.xlsx')
      })
      .catch((error) => {
        toast.error('Erro ao exportar contatos')
        setDownloadLoading(false)
      })
  }, [profile.id_dominio])

  const handleExportRange = useCallback(() => {
    setDownloadLoading(true)

    api
      .get('/export/contacts/range', {
        params: {
          fk_id_dominio: profile.id_dominio,
          start: startDate ? startDate.toISOString() : undefined,
          end: endDate ? endDate.toISOString() : undefined,
        },
        responseType: 'blob',
      })
      .then((response) => {
        setDownloadLoading(false)
        FileDownload(response.data, 'contatos_atualizados.xlsx')
      })
      .catch((error) => {
        toast.error('Erro ao exportar contatos')
        setDownloadLoading(false)
      })
  }, [profile.id_dominio, startDate, endDate])

  useEffect(() => {
    // dispatch(getContactsRequest({ ident, did }))
    getContacts()
  }, [getContacts])

  return (
    <ContainerSemantic>
      {showSearch && (
        <div
          style={{
            width: '100%',
            margin: '0px 5px',
            display: 'flex',
            justifyContent: 'space-between',
            padding: '8px',
            borderRadius: '0.28571429rem',
            boxShadow:
              '0 0 0 1px rgba(34, 36, 38, .22) inset, 0 0 0 0 transparent',
            // backgroundColor: '#fff',
            transition:
              'opacity .1s ease, color .1s ease, background .1s ease, box-shadow .1s ease',
            backgroundColor: 'rgba(0, 0, 0, .02)',
            animation: 'fadeIn 0.3s ease-in-out forwards',
          }}
        >
          <ContainerHeader>
            <div className="menu_lateral">
              <div className="campo_busca">
                <p>Numero</p>
                <Input
                  id="did"
                  type="text"
                  value={did}
                  placeholder="DID"
                  onChange={(e) => {
                    setDid(e.target.value)
                    setCurrentPage(1) // Reset to first page when changing search criteria
                  }}
                />
              </div>

              <div className="campo_busca">
                <p>Nome</p>
                <Input
                  id="identificacao"
                  type="text"
                  value={ident}
                  placeholder="Identificação"
                  onChange={(e) => {
                    setIdent(e.target.value)
                    setCurrentPage(1) // Reset to first page when changing search criteria
                  }}
                />
              </div>

              <div className="campo_busca">
                <p>Buscar Por Campo Customizado</p>
                <Input
                  id="campo_custom"
                  type="text"
                  value={campoCustom}
                  placeholder="Campo Customizado"
                  onChange={(e) => {
                    setCampoCustom(e.target.value)
                    setCurrentPage(1) // Reset to first page when changing search criteria
                  }}
                />
              </div>

              <div className="campo_busca">
                {/* <div className="Search_Control"> */}
                <label htmlFor="start">Inicio</label>
                <div className="ui input">
                  <DatePicker
                    id="start"
                    showPopperArrow={false}
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    showTimeSelect
                    timeFormat="HH:mm:ss"
                    timeIntervals={15}
                    timeCaption="time"
                    dateFormat="dd-MM-yyyy HH:mm:ss"
                    className="input_date"
                    withPortal
                  />
                </div>
                {/* </div> */}
              </div>

              <div className="campo_busca">
                {/* <div className="Search_Control"> */}
                <label htmlFor="end">Termino</label>
                <div className="ui input">
                  <DatePicker
                    id="end"
                    showPopperArrow={false}
                    selected={endDate}
                    onChange={(date) => setEndDate(date)}
                    showTimeSelect
                    timeFormat="HH:mm:ss"
                    timeIntervals={15}
                    timeCaption="time"
                    dateFormat="dd-MM-yyyy HH:mm:ss"
                    className="input_date"
                    withPortal
                  />
                </div>
                {/* </div> */}
              </div>
            </div>

            <div className="menu_lateral">
              <div style={{ display: 'flex', gap: '2px' }}>
                <Link to="/contatos/add">
                  <Button fluid primary>
                    Adicionar
                  </Button>
                </Link>
                <Link to="/contatos/template">
                  <Button fluid color="green">
                    Template
                  </Button>
                </Link>
              </div>

              <ButtonGroup>
                <Button
                  loading={downloadLoading}
                  type="button"
                  // fluid
                  // color="yellow"
                  onClick={handleExport}
                >
                  <Icon disabled name="download" />
                  Exportar
                </Button>
                <Button
                  loading={downloadLoading}
                  type="button"
                  // fluid
                  // color="yellow"
                  icon="play"
                  onClick={() => {
                    if (startDate && endDate) {
                      handleExportRange()
                    } else {
                      handleExportUpdated()
                    }
                  }}
                >
                  <Icon disabled name="download" />
                  Exportar Alterados
                </Button>
              </ButtonGroup>

              <Button
                type="button"
                color="red"
                onClick={() => {
                  setShowSearch(false)
                }}
              >
                Fechar
              </Button>
            </div>
          </ContainerHeader>
        </div>
      )}

      <div
        className="ui cards"
        style={{
          overflowY: 'auto',
          // maxHeight: 'calc(100vh - 120px)',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            flex: 1,
            marginTop: '5px',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            {!showSearch && (
              <Button color="blue" icon onClick={() => setShowSearch(true)}>
                <Icon name="filter" />
              </Button>
            )}
            <Pagination
              size="mini"
              boundaryRange={0}
              defaultActivePage={1}
              ellipsisItem={null}
              firstItem={null}
              lastItem={null}
              siblingRange={1}
              totalPages={totalPages}
              onPageChange={(e, { activePage }) => {
                setCurrentPage(activePage)
              }}
              activePage={currentPage}
              prevItem={null}
              nextItem={null}
            />
            <div>
              <strong> Total: </strong>
              <span style={{ fontWeight: 'bold' }}>{totalCount}</span>
              <span> Contatos</span>
            </div>
          </div>

          <Select
            placeholder="Quantidade de itens"
            options={qtdSelectOptions}
            // defaultValue="20"
            onChange={(e, { value }) => {
              setCurrentPage(1) // Reset to first page when changing items per page
              setSelectqtdContatos(value)
            }}
            value={selectqtdContatos}
          />
        </div>

        <Table celled style={{ marginTop: '5px', marginBottom: '5px' }}>
          <TableHeader>
            <TableRow>
              <TableHeaderCell
                style={{ textAlign: 'center', verticalAlign: 'middle' }}
              >
                #
              </TableHeaderCell>
              <TableHeaderCell
                style={{ textAlign: 'center', verticalAlign: 'middle' }}
              >
                Numero
              </TableHeaderCell>
              <TableHeaderCell
                style={{ textAlign: 'center', verticalAlign: 'middle' }}
              >
                Nome
              </TableHeaderCell>
              <TableHeaderCell
                style={{ textAlign: 'center', verticalAlign: 'middle' }}
              >
                Fraseologia
              </TableHeaderCell>
            </TableRow>
          </TableHeader>
          <TableBody>
            {contatos.rows?.map((contato) => {
              return (
                <TableRow key={contato.id}>
                  <TableCell
                    style={{ textAlign: 'center', verticalAlign: 'middle' }}
                  >
                    <Link to={`/contato/${contato.id}`}>{contato.id}</Link>
                  </TableCell>

                  <TableCell
                    style={{ textAlign: 'center', verticalAlign: 'middle' }}
                  >
                    {contato.ContactNumbers.map((number) => {
                      return (
                        <Label key={number.id} horizontal color="teal">
                          {number.numero}
                        </Label>
                      )
                    })}
                  </TableCell>

                  <TableCell
                    style={{ textAlign: 'center', verticalAlign: 'middle' }}
                  >
                    {contato.descricao}
                  </TableCell>

                  <TableCell
                    style={{ textAlign: 'center', verticalAlign: 'middle' }}
                  >
                    {contato.fraseologia}
                  </TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </div>
    </ContainerSemantic>
  )
}
